import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';
import { RemediationModalComponent } from '../remediation-modal/remediation-modal.component';

@Component({
  selector: 'kh-teacher-remediation-modal',
  templateUrl: './teacher-remediation-modal.component.html',
  styleUrls: ['./teacher-remediation-modal.component.less'],
  standalone: false
})
export class TeacherRemediationModalComponent extends RemediationModalComponent {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);

  public classId = this.activatedRoute.snapshot.paramMap.get('classId') as string;

  public async goToTeacherStudentGapDetail(logicalErrorId: string): Promise<void> {
    const route = TEACHER_ROUTE.REMEDIATION.route(this.classInfo.ClassId, logicalErrorId);
    await this.router.navigate(route);
    this.closeModal();
  }
}
